/**
 * 时间格式化
 * data 时间值
 * type 格式化类型，暂支持四种格式(1,2,3,4)默认为1
 * 格式1 yyyy-mm-dd HH:mm:ss
 * 格式2 yyyy-mm-dd
 * 格式3 yyyy-mm-dd 00:00:00
 * 格式4 yyyy-mm-dd 23:59:59
 */
function timeFormat(data, type = 1) {
  let timeData = "";
  if (data) {
    data += "";
    timeData = new Date(data.replace(/-/g, "/"));
    const y = timeData.getFullYear();
    const m = (timeData.getMonth() + 1).toString().padStart(2, "0");
    const d = (timeData.getDate() + 0).toString().padStart(2, "0");
    const h = (timeData.getHours() + 0).toString().padStart(2, "0");
    const min = (timeData.getMinutes() + 0).toString().padStart(2, "0");
    const s = (timeData.getSeconds() + 0).toString().padStart(2, "0");
    switch (type) {
      case 1:
        timeData = `${y}-${m}-${d} ${h}:${min}:${s}`;
        break;
      case 2:
        timeData = `${y}-${m}-${d}`;
        break;
      case 3:
        timeData = `${y}-${m}-${d} 00:00:00`;
        break;
      case 4:
        timeData = `${y}-${m}-${d} 23:59:59`;
        break;
      case 5:
        timeData = `${h}:${min}:${s}`;
        break;
      default:
        break;
    }
  }
  return timeData;
}

// 根据身份证号获取生日
function getBirthdayFromIdCard(idCard) {
  if (!idCard) {
    return "";
  }
  var birthday = "";
  if (idCard !== null && idCard !== "") {
    if (idCard.length === 15) {
      birthday = "19" + idCard.substr(6, 6);
    } else if (idCard.length === 18) {
      birthday = idCard.substr(6, 8);
    }
    birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
  }
  return birthday;
}

// 计算时间差
function getTimeDifference(time1, time2) {
  var time3 = time2.getTime() - new Date(time1).getTime(); // 时间差的毫秒数
  // //计算出相差天数
  // var days = Math.floor(time3 / (24 * 3600 * 1000));
  //计算出小时数
  var leave1 = time3 % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000);
  let difference =
    Math.round((hours + minutes / 60 + seconds / 3600) * 100) / 100;
  return difference;
}

// 判断浏览器类型
function myBrowser() {
  const userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  const isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    return "Opera";
  }
  if (userAgent.indexOf("Firefox") > -1) {
    return "FF";
  }
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  }
  if (
    userAgent.indexOf("compatible") > -1 &&
    userAgent.indexOf("MSIE") > -1 &&
    !isOpera
  ) {
    return "IE";
  }
  if (userAgent.indexOf("Trident") > -1) {
    return "Edge";
  }
  return "";
}

/**
 * 根据身份证号码获取性别
 * 0: 男性
 * 1：女性
 */
const getSex = idCard => {
  var sexStr = "";
  if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
    sexStr = 0;
  } else {
    sexStr = 1;
  }
  return sexStr;
};

export {
  timeFormat,
  getBirthdayFromIdCard,
  getTimeDifference,
  myBrowser,
  getSex
};
